import { create } from 'zustand'
import merge from 'lodash/merge'
import axios from 'axios'
import { saveContactAddressCountry, saveContactData, withGlobalFormData } from './helpers'
import { getFormConfig } from './forms/helpers'

export const BASE_URL = import.meta.env.REACT_APP_WEB_ADMIN_API || ''

interface StoreState {
  steps: Array<any>
  stepsVisibility: any
  currentStep: number
  isLoading: boolean
  setCurrentStep: (arg0: number) => void
  data: any
  summary: any
  url: string | null
  successData: any
  selectedCountry: string
  setSummary: (arg0: any) => void
  updateSummary: (arg0: any, arg1: any) => void
  nextStep: (arg0?: any) => void
  prevStep: (arg0: any) => void
  addDataForStep: (arg0: any) => void
  setStepVisibility: (arg0: any, arg1: any) => void
  setIsLoading: (arg0: any) => void
  setSelectedCountry: (arg0: string) => void
  setUrl: (arg0: string) => void
  sendData: () => Promise<any>
}

export const useStore = create<StoreState>()((set, get) => ({
  steps: [],
  stepsVisibility: {},
  currentStep: 0,
  isLoading: false,
  setCurrentStep: (step: number) => set({ currentStep: step }),
  data: {},
  summary: {},
  url: null,
  successData: null,
  selectedCountry: '',

  setSummary: (newSummary) =>
    set(({ summary }) => ({
      summary: {
        ...summary,
        ...newSummary,
        steps: newSummary.steps.map((step) => {
          const existingValues = summary?.steps?.find((s) => s.key === step.key)
          if (existingValues) {
            return {
              ...existingValues,
              ...step,
            }
          }
          return step
        }),
      },
    })),
  updateSummary: (key, summaryUpdate) => {
    set(({ summary }) => ({
      summary: {
        ...summary,
        steps: summary?.steps?.map((summaryPart) =>
          summaryPart.key === key
            ? { ...summaryPart, ...summaryUpdate }
            : summaryPart,
        ),
      },
    }))
  },
  nextStep: (successData) => {
    set(({ currentStep, steps }) => ({
      successData,
      currentStep:
        currentStep === steps.length - 1 ? currentStep : currentStep + 1,
    }))
  },

  prevStep: () => {
    set(({ currentStep }) => ({
      currentStep: currentStep > 0 ? currentStep - 1 : 0,
    }))
  },

  addDataForStep: (stepData) => {
    return set(({ data }) => ({ data: merge(data, stepData) }))
  },

  setStepVisibility: (stepKey: string, visible: boolean) =>
    set(({ stepsVisibility }) => ({
      stepsVisibility: merge({}, stepsVisibility, { [stepKey]: visible }),
    })),

  setIsLoading: (isLoading: boolean) => set({ isLoading }),

  setSelectedCountry: (selectedCountry: string) => set({ selectedCountry }),

  setUrl: (url: string) => set({ url }),

  sendData: () => {
    set({ isLoading: true })
    saveContactData(get().data)
    saveContactAddressCountry(get().data)
    return axios.post(`${BASE_URL}${get().url}`, withGlobalFormData(get().data))
  },
}))
